import { render } from "./Footer.vue?vue&type=template&id=1eb43f9a"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1eb43f9a&lang=scss"

import exportComponent from "/Users/sarah.veysset/S/TRAVAIL/FREELANCE/OSTEO BARRY/osteo-barry/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__